import { Component, Input, Output, EventEmitter } from '@angular/core';
import { QPilotProduct } from '../../types/product';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BundleProductDto } from '../bundle.interfaces';

@Component({
  selector: 'lib-bundle-product-list-item-selected',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './bundle-product-list-item-selected.component.html',
  styleUrl: './bundle-product-list-item-selected.component.scss',
})
export class BundleProductListItemSelectedComponent {
  @Input() product: BundleProductDto | undefined;
  @Input() selectedProducts: BundleProductDto[];
  @Output() remove = new EventEmitter<BundleProductDto>();

  onRemove() {
    this.remove.emit(this.product);
  }
}
